var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      ref: "modal",
      attrs: {
        name: "create-project-modal",
        "content-classes": "default-modal width-sm",
        title: _vm.title,
        autofocus: _vm.$refs.projectName
      },
      model: {
        value: _vm.modalOpened,
        callback: function($$v) {
          _vm.modalOpened = $$v
        },
        expression: "modalOpened"
      }
    },
    [
      _c(
        "q-stepper",
        {
          ref: "stepper",
          staticClass: "no-shadow",
          model: {
            value: _vm.step,
            callback: function($$v) {
              _vm.step = $$v
            },
            expression: "step"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-body big-modal-scroll col scroll",
              staticStyle: { "min-height": "280px" }
            },
            [
              _c(
                "q-step",
                { attrs: { default: "", title: "Projektdaten", name: "base" } },
                [
                  _c("div", { staticClass: "q-px-sm q-py-lg" }, [
                    _c("div", { staticClass: "row items-center gutter-x-md" }, [
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "q-field",
                            {
                              staticClass: "q-ma-none",
                              attrs: {
                                error: _vm.errors.has("name"),
                                "error-label": _vm.errors.first("name")
                              }
                            },
                            [
                              _c("q-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate.disable",
                                    value: "required|max:255",
                                    expression: "'required|max:255'",
                                    modifiers: { disable: true }
                                  }
                                ],
                                ref: "projectName",
                                attrs: {
                                  name: "name",
                                  placeholder: _vm.$t("name"),
                                  "float-label": _vm.$t("name")
                                },
                                on: {
                                  keydown: function($event) {
                                    if (
                                      !("button" in $event) &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.handleSaveProject($event)
                                  }
                                },
                                model: {
                                  value: _vm.formData.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "name", $$v)
                                  },
                                  expression: "formData.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-auto" },
                        [
                          _c("div", {
                            staticClass: "project__color-picker circle",
                            style: { "background-color": _vm.formData.colorHex }
                          }),
                          _c("color-picker-popover", {
                            ref: "colorPicker",
                            attrs: { colors: _vm.projectColors },
                            model: {
                              value: _vm.formData.colorHex,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "colorHex", $$v)
                              },
                              expression: "formData.colorHex"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("customer-input", {
                            attrs: {
                              "float-label": _vm.$tc("customer", 1),
                              placeholder: null
                            },
                            model: {
                              value: _vm.formData.customer,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "customer", $$v)
                              },
                              expression: "formData.customer"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "row gutter-x-md" }, [
                      _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c(
                            "q-field",
                            {
                              attrs: {
                                error: _vm.errors.has("startDate"),
                                "error-label": _vm.errors.first("startDate")
                              }
                            },
                            [
                              _c("q-datetime", {
                                attrs: {
                                  type: "date",
                                  name: "startDate",
                                  "float-label": _vm.$t("start_date"),
                                  placeholder: _vm.$t("start_date")
                                },
                                model: {
                                  value: _vm.formData.startDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "startDate", $$v)
                                  },
                                  expression: "formData.startDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c(
                            "q-field",
                            {
                              attrs: {
                                error: _vm.errors.has("endDate"),
                                "error-label": _vm.errors.first("endDate")
                              }
                            },
                            [
                              _c("q-datetime", {
                                attrs: {
                                  type: "date",
                                  name: "endDate",
                                  "float-label": _vm.$t("end_date"),
                                  placeholder: _vm.$t("end_date")
                                },
                                model: {
                                  value: _vm.formData.endDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "endDate", $$v)
                                  },
                                  expression: "formData.endDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ]
              ),
              _c(
                "q-step",
                { attrs: { title: _vm.$t("project_budget"), name: "budget" } },
                [
                  _c(
                    "div",
                    { staticClass: "q-px-sm q-py-lg" },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 flex justify-center" },
                          [
                            _c("q-btn-toggle", {
                              staticClass: "no-shadow",
                              staticStyle: {
                                border: "1px solid var(--q-color-light)"
                              },
                              attrs: {
                                options: _vm.projectTypesSelectOptions,
                                "toggle-color": "light"
                              },
                              model: {
                                value: _vm.formData.projectType,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "projectType", $$v)
                                },
                                expression: "formData.projectType"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _c("div", { staticClass: "row gutter-x-md" }, [
                        _vm.showHourlyRateField
                          ? _c(
                              "div",
                              { staticClass: "col-6" },
                              [
                                _c(
                                  "q-field",
                                  {
                                    attrs: {
                                      error: _vm.errors.has("rate"),
                                      "error-label": _vm.errors.first("rate")
                                    }
                                  },
                                  [
                                    _c("q-input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate.disable",
                                          value: "decimal:2|min:0",
                                          expression: "'decimal:2|min:0'",
                                          modifiers: { disable: true }
                                        }
                                      ],
                                      attrs: {
                                        type: "number",
                                        name: "rate",
                                        placeholder: _vm.$t("hourly_rate"),
                                        "float-label": _vm.$t("hourly_rate"),
                                        suffix:
                                          _vm.defaultCurrencySymbol +
                                          "/" +
                                          _vm.$tc("hour")
                                      },
                                      model: {
                                        value: _vm.formData.rate,
                                        callback: function($$v) {
                                          _vm.$set(_vm.formData, "rate", $$v)
                                        },
                                        expression: "formData.rate"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            class: {
                              "col-6": _vm.showHourlyRateField,
                              "col-12": !_vm.showHourlyRateField
                            }
                          },
                          [
                            _c(
                              "q-field",
                              {
                                attrs: {
                                  error: _vm.errors.has("estimatedHours"),
                                  "error-label": _vm.errors.first(
                                    "estimatedHours"
                                  )
                                }
                              },
                              [
                                _c("q-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate.disable",
                                      value: "numeric|min:0",
                                      expression: "'numeric|min:0'",
                                      modifiers: { disable: true }
                                    }
                                  ],
                                  attrs: {
                                    type: "number",
                                    name: "estimatedHours",
                                    placeholder: _vm.$t("estimated_hours"),
                                    "float-label": _vm.$t("estimated_hours"),
                                    suffix: _vm.$tc(
                                      "hour",
                                      _vm.formData.estimatedHours
                                    ),
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.formData.estimatedHours,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "estimatedHours",
                                        $$v
                                      )
                                    },
                                    expression: "formData.estimatedHours"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm.showBudgetField
                        ? _c(
                            "q-field",
                            {
                              attrs: {
                                error: _vm.errors.has("budget"),
                                "error-label": _vm.errors.first("budget")
                              }
                            },
                            [
                              _c("q-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate.disable",
                                    value: "decimal:2|min:0",
                                    expression: "'decimal:2|min:0'",
                                    modifiers: { disable: true }
                                  }
                                ],
                                attrs: {
                                  type: "number",
                                  name: "budget",
                                  placeholder: _vm.$t("project_budget"),
                                  "float-label": _vm.$t("project_budget"),
                                  suffix: _vm.defaultCurrencySymbol
                                },
                                model: {
                                  value: _vm.formData.budget,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "budget", $$v)
                                  },
                                  expression: "formData.budget"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "div",
              { staticClass: "row justify-between full-width" },
              [
                _vm.step !== "budget"
                  ? _c("div", { staticClass: "order-first" })
                  : _vm._e(),
                _vm.step !== "budget"
                  ? _c("q-btn", {
                      staticClass: "order-last",
                      attrs: { label: _vm.$t("next"), flat: "" },
                      on: { click: _vm.handleStepNext }
                    })
                  : _vm._e(),
                _vm.step !== "base"
                  ? _c("q-btn", {
                      staticClass: "order-last",
                      attrs: { label: _vm.$t("back"), flat: "" },
                      on: { click: _vm.handleStepPrevious }
                    })
                  : _vm._e(),
                _vm.step !== "base"
                  ? _c(
                      "q-btn",
                      {
                        ref: "submitBtn",
                        staticClass: "order-last",
                        attrs: {
                          color: "positive",
                          disabled: !this.formData.name
                        },
                        on: { click: _vm.handleSaveProject }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(_vm.$t("save")) + "\n        "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }